/* ==========================================================================
   CLAYDALE — catálogo (v2)
   Se carga UNA sola vez desde layout/theme.liquid, no desde las secciones:
   incluirlo por sección lo ejecuta N veces y duplica los escuchadores (eso es
   lo que rompió los acordeones de la v1).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__cd2Arrancado) return;
  window.__cd2Arrancado = true;

  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* --- Galería de la ficha -------------------------------------------------
     La pista se desliza sola (scroll-snap). El JS solo mantiene sincronizados
     el contador y las miniaturas.                                           */
  function initGaleria() {
    document.querySelectorAll('[data-cd2-gal]').forEach(function (gal) {
      // Marcada antes de atarla: así se puede volver a llamar sin duplicar.
      if (gal.__cd2Atada) return;
      gal.__cd2Atada = true;
      var pista  = gal.querySelector('[data-cd2-gal-pista]');
      var cuenta = gal.querySelector('[data-cd2-gal-cuenta]');
      var minis  = gal.querySelectorAll('[data-cd2-gal-minis] .cd2-gal__mini');
      if (!pista) return;

      var fotos = pista.querySelectorAll('.cd2-gal__foto');
      if (!fotos.length) return;

      function indice() {
        var ancho = pista.clientWidth || 1;
        return Math.round(pista.scrollLeft / ancho);
      }

      function pinta() {
        var i = Math.min(Math.max(indice(), 0), fotos.length - 1);
        if (cuenta) cuenta.textContent = (i + 1) + '/' + fotos.length;
        minis.forEach(function (m, j) {
          if (j === i) m.setAttribute('aria-current', 'true');
          else m.removeAttribute('aria-current');
        });
        gal.querySelectorAll('[data-cd2-gal-ir]').forEach(function (b) {
          var paso = parseInt(b.getAttribute('data-cd2-gal-ir'), 10) || 1;
          var fin = paso < 0 ? i === 0 : i === fotos.length - 1;
          b.disabled = fin;
        });
      }

      minis.forEach(function (m, j) {
        m.addEventListener('click', function () {
          pista.scrollTo({ left: pista.clientWidth * j, behavior: 'smooth' });
          // El evento scroll puede no llegar si el navegador tiene la pestaña
          // en segundo plano: se pinta también a mano.
          setTimeout(pinta, 320);
        });
      });

      // Flechas de pantalla grande: mueven la pista un ancho, que es
      // exactamente una foto, y el scroll-snap remata el encaje.
      gal.querySelectorAll('[data-cd2-gal-ir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var paso = parseInt(b.getAttribute('data-cd2-gal-ir'), 10) || 1;
          var destino = Math.min(Math.max(indice() + paso, 0), fotos.length - 1);
          pista.scrollTo({ left: pista.clientWidth * destino, behavior: 'smooth' });
          setTimeout(pinta, 320);
        });
      });

      pista.addEventListener('scroll', pinta, { passive: true });
      window.addEventListener('resize', pinta);
      pinta();
    });
  }

  /* --- Desplegables de la ficha ------------------------------------------- */
  function initDesplegables() {
    document.querySelectorAll('[data-cd2-des]').forEach(function (caja) {
      caja.querySelectorAll('.cd2-des__b').forEach(function (b) {
        if (b.__cd2Atado) return;
        b.__cd2Atado = true;
        b.addEventListener('click', function () {
          var abierto = b.getAttribute('aria-expanded') === 'true';
          b.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        });
      });
    });
  }

  /* --- Reserva sitio al pie cuando hay barra fija de compra ---------------- */
  function initHuecoBarra() {
    if (document.querySelector('[data-cd-barra]')) {
      document.body.classList.add('cd2-con-barra');
    }
  }

  /* --- VISTA PREVIA (solo en el tema de pruebas) ---------------------------
     Mientras los cuatro productos estén en borrador no existen para la tienda,
     así que no hay página de producto que abrir. La página de "no encontrado"
     del tema de pruebas lleva las cuatro fichas montadas y esto deja a la vista
     solo la que pide la dirección: /vista/bruma, /vista/crema, /vista/balsamo
     o /vista/retinal. Se quita el día que los productos se publiquen.        */
  function initVistaPrevia() {
    var fichas = document.querySelectorAll('[data-cd2-vista]');
    if (fichas.length < 2) return;
    var ruta = (location.pathname + location.hash).toLowerCase();
    var elegida = null;
    fichas.forEach(function (f) {
      var k = f.getAttribute('data-cd2-vista');
      if (!elegida && k && ruta.indexOf(k) > -1) elegida = f;
    });
    if (!elegida) elegida = fichas[0];
    fichas.forEach(function (f) {
      if (f !== elegida) {
        var caja = f.closest('[id^="shopify-section-"]') || f;
        caja.parentNode.removeChild(caja);
      }
    });
  }

  listo(function () {
    initVistaPrevia();
    initGaleria();
    initDesplegables();
    initHuecoBarra();
  });
})();

/* ==========================================================================
   Portada de catálogo grande: banner rotatorio y filas de productos.
   Va en un bloque aparte para no tocar lo de arriba.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__cd2PortadaArrancada) return;
  window.__cd2PortadaArrancada = true;

  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* --- Banner rotatorio ---------------------------------------------------
     La pista es un carrusel de scroll normal, así que arrastrar con el dedo
     funciona sin JS. Esto solo añade flechas, puntos y el giro opcional.     */
  function initBanners() {
    document.querySelectorAll('[data-cd2-bn]').forEach(function (bn) {
      var pista  = bn.querySelector('[data-cd2-bn-pista]');
      if (!pista) return;
      var slides = pista.querySelectorAll('.cd2-bn__slide');
      if (slides.length < 2) return;

      var puntos = bn.querySelectorAll('[data-cd2-bn-puntos] .cd2-bn__punto');
      var izq = bn.querySelector('[data-cd2-bn-izq]');
      var der = bn.querySelector('[data-cd2-bn-der]');
      var reloj = null;
      var tocado = false;

      function indice() {
        return Math.round(pista.scrollLeft / (pista.clientWidth || 1));
      }
      function pinta() {
        var i = Math.min(Math.max(indice(), 0), slides.length - 1);
        puntos.forEach(function (p, j) {
          if (j === i) p.setAttribute('aria-current', 'true');
          else p.removeAttribute('aria-current');
        });
      }
      function ve(i) {
        var n = (i + slides.length) % slides.length;
        pista.scrollTo({ left: pista.clientWidth * n, behavior: 'smooth' });
        setTimeout(pinta, 340);
      }

      if (izq) izq.addEventListener('click', function () { para(); ve(indice() - 1); });
      if (der) der.addEventListener('click', function () { para(); ve(indice() + 1); });
      puntos.forEach(function (p, j) {
        p.addEventListener('click', function () { para(); ve(j); });
      });

      pista.addEventListener('scroll', pinta, { passive: true });
      window.addEventListener('resize', pinta);

      function para() {
        tocado = true;
        if (reloj) { clearInterval(reloj); reloj = null; }
      }
      // Cualquier gesto del visitante manda: el giro automático se para y no
      // vuelve. Un carrusel que sigue moviéndose mientras alguien lee molesta.
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
        bn.addEventListener(ev, para, { passive: true });
      });

      // Quien tiene activado "reducir movimiento" en su sistema no recibe
      // nada que se mueva solo. Es un ajuste de accesibilidad, no un capricho.
      var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (bn.getAttribute('data-auto') === 'true' && !quieto) {
        var seg = parseInt(bn.getAttribute('data-seg'), 10) || 6;
        reloj = setInterval(function () {
          if (tocado || document.hidden) return;
          ve(indice() + 1);
        }, seg * 1000);
      }

      pinta();
    });
  }

  /* --- Flechas de las filas de productos ---------------------------------- */
  function initFilas() {
    document.querySelectorAll('[data-cd2-fila]').forEach(function (caja) {
      var pista = caja.querySelector('[data-cd2-fila-pista]');
      var izq = caja.querySelector('[data-cd2-fila-izq]');
      var der = caja.querySelector('[data-cd2-fila-der]');
      if (!pista) return;

      function estado() {
        var max = pista.scrollWidth - pista.clientWidth - 4;
        if (izq) izq.disabled = pista.scrollLeft <= 4;
        if (der) der.disabled = pista.scrollLeft >= max;
      }
      function salto() {
        var t = pista.querySelector('.cd2-card');
        return t ? t.getBoundingClientRect().width * 2 + 40 : pista.clientWidth * 0.8;
      }
      if (izq) izq.addEventListener('click', function () { pista.scrollBy({ left: -salto(), behavior: 'smooth' }); setTimeout(estado, 360); });
      if (der) der.addEventListener('click', function () { pista.scrollBy({ left:  salto(), behavior: 'smooth' }); setTimeout(estado, 360); });

      pista.addEventListener('scroll', estado, { passive: true });
      window.addEventListener('resize', estado);
      estado();
    });
  }

  listo(function () {
    initBanners();
    initFilas();
  });
})();

/* ==========================================================================
   ¿CUÁNDO LLEGA?
   Calcula la fecha real de entrega con las reglas de Dropea:
     · hora de corte del proveedor (la suya son las 16:00, hora de España)
     · antes del corte y en día hábil -> sale HOY
     · después del corte, fin de semana o festivo -> sale el siguiente hábil
     · entrega en 24/48 h HÁBILES -> 1 o 2 días hábiles después de salir
   Se calcula siempre en hora de España, no en la del visitante: si alguien
   mira la web desde Canarias o de viaje, la hora de corte sigue siendo la de
   la nave.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__cd2EntregaArrancada) return;
  window.__cd2EntregaArrancada = true;

  var DIAS = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
  var MESES = ['enero','febrero','marzo','abril','mayo','junio','julio',
               'agosto','septiembre','octubre','noviembre','diciembre'];

  /* Fecha y hora actuales EN ESPAÑA, saliendo de la zona del navegador. */
  function ahoraEnEspana() {
    var f = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit',
      day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    }).formatToParts(new Date());
    var v = {};
    f.forEach(function (p) { v[p.type] = p.value; });
    // Se construye en UTC para que los cálculos de días no se descoloquen
    return new Date(Date.UTC(+v.year, +v.month - 1, +v.day,
                             +(v.hour === '24' ? 0 : v.hour), +v.minute, +v.second));
  }

  function clave(d) {
    return d.getUTCFullYear() + '-' +
           String(d.getUTCMonth() + 1).padStart(2, '0') + '-' +
           String(d.getUTCDate()).padStart(2, '0');
  }

  function esHabil(d, festivos) {
    var s = d.getUTCDay();
    if (s === 0 || s === 6) return false;
    return festivos.indexOf(clave(d)) === -1;
  }

  /* Avanza n días HÁBILES desde d (n = 0 devuelve el mismo día). */
  function sumaHabiles(d, n, festivos) {
    var x = d;
    for (var i = 0; i < n; i++) x = siguienteHabil(x, festivos);
    return x;
  }

  function siguienteHabil(d, festivos) {
    var x = new Date(d.getTime());
    do { x.setUTCDate(x.getUTCDate() + 1); } while (!esHabil(x, festivos));
    return x;
  }

  function texto(d, conMes) {
    var t = DIAS[d.getUTCDay()] + ' ' + d.getUTCDate();
    if (conMes) t += ' de ' + MESES[d.getUTCMonth()];
    return t;
  }

  function initEntrega() {
    document.querySelectorAll('[data-cd2-entrega]').forEach(function (caja) {
      // 3 nov 2026 · recuadro de la cesta: se vuelve a llamar cuando Dawn repinta la cesta (abajo). Marcada para no atarla dos veces.
      if (caja.__cd2Atada) return;
      caja.__cd2Atada = true;
      var corte = (caja.getAttribute('data-corte') || '16:00').split(':');
      var corteMin = (+corte[0]) * 60 + (+corte[1] || 0);
      var festivos = (caja.getAttribute('data-festivos') || '')
        .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var rango = caja.getAttribute('data-rango') === 'true';
      // Cuántos días hábiles tarda desde que sale el pedido. Por defecto 1 y 2
      // (el 24/48 h del almacén), pero los productos bajo demanda mandan los
      // suyos, que son muchos más.
      var diasMin = parseInt(caja.getAttribute('data-dias-min'), 10) || 1;
      var diasMax = parseInt(caja.getAttribute('data-dias-max'), 10) || (diasMin + 1);
      if (diasMax < diasMin) diasMax = diasMin;
      // La cuenta atrás hasta la hora de corte solo tiene sentido cuando el
      // pedido sale HOY. En lo que se prepara bajo demanda no aporta nada.
      var cuenta = caja.getAttribute('data-cuenta') !== 'false';
      var salida = caja.querySelector('[data-cd2-entrega-txt]');
      var reloj  = caja.querySelector('[data-cd2-entrega-reloj]');
      if (!salida) return;

      function pinta() {
        var hoy = ahoraEnEspana();
        var minutosAhora = hoy.getUTCHours() * 60 + hoy.getUTCMinutes();
        var aTiempo = esHabil(hoy, festivos) && minutosAhora < corteMin;

        var dia = aTiempo ? hoy : siguienteHabil(hoy, festivos);
        var min = sumaHabiles(dia, diasMin, festivos);
        var max = sumaHabiles(dia, diasMax, festivos);

        var mesDistinto = min.getUTCMonth() !== hoy.getUTCMonth();
        var dosFechas = rango && clave(max) !== clave(min);
        var cuando = dosFechas
          ? ('el <span class="cd2-entrega__fecha">' + texto(min, false) +
             '</span> o el <span class="cd2-entrega__fecha">' + texto(max, max.getUTCMonth() !== hoy.getUTCMonth()) + '</span>')
          : ('el <span class="cd2-entrega__fecha">' + texto(min, mesDistinto) + '</span>');

        if (aTiempo && cuenta) {
          var quedan = corteMin - minutosAhora;
          var h = Math.floor(quedan / 60), m = quedan % 60;
          var reste = h > 0 ? (h + ' h ' + m + ' min') : (m + ' min');
          salida.innerHTML = 'Pídelo en las próximas <span class="cd2-entrega__reloj">' +
            reste + '</span> y lo recibes ' + cuando + '.';
        } else {
          salida.innerHTML = 'Pídelo ahora y lo recibes ' + cuando + '.';
        }
        if (reloj) reloj.textContent = '';
      }

      pinta();
      // Cada 30 s: suficiente para que la cuenta atrás no se quede pillada y
      // barato de sobra. setInterval y no requestAnimationFrame, que se congela
      // con la pestaña en segundo plano.
      // Si Dawn ha cambiado ese trozo de la cesta, esta caja ya no está en la página y se deja de pintar.
      var cada = setInterval(function () {
        if (!caja.isConnected) { clearInterval(cada); return; }
        pinta();
      }, 30000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEntrega);
  } else {
    initEntrega();
  }

  /* 3 nov 2026 · recuadro de la cesta. La página de la cesta lleva el mismo recuadro (sections/main-cart-footer.liquid). Al cambiar unidades, Dawn
     repinta ese trozo desde el servidor y el recuadro nuevo llega con el texto de respaldo: se calcula su fecha en cuanto Dawn
     avisa de que la cesta ha cambiado (el mismo aviso que usa cd-scripts.js para el regalo; Dawn lo publica después de repintar). */
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { initEntrega(); });
    }
  } catch (e) {}

  /* --- El editor de temas ---------------------------------------------------
     Este fichero se blinda con `__cd2Arrancado` para no ejecutarse dos veces, y
     eso está bien en la tienda. Pero en el EDITOR, cada vez que se recarga una
     sección, el HTML nuevo viene sin atar y aquí no se re-inicializaba nada:
     después de tocar la ficha, la galería, sus flechas y el contador de fotos
     dejaban de responder hasta recargar la página a mano.
     Ahora se vuelven a llamar las dos que atan elementos. Son idempotentes:
     cada elemento lleva su marca (`__cd2Atada` / `__cd2Atado`), así que esto
     solo puede atar lo NUEVO, nunca duplicar lo que ya estaba. 9 sept 2026. */
  document.addEventListener('shopify:section:load', function () {
    try { initGaleria(); initDesplegables(); initHuecoBarra(); }
    catch (e) {
      if (window.console && console.error) { console.error('[cd2] recarga de sección', e); }
    }
  });
})();
